import moment from 'moment'

export default navigationLoggerRun

/** @ngInject */
function navigationLoggerRun($rootScope, $stateParams, $cookies, $location, LogNavigation, PermPermissionStore) {
    return $rootScope.$on('$stateChangeSuccess', (event, next, current) => {
        if ($stateParams.from) {
            $cookies.put('providerPartner', $stateParams.from, { expires: moment().add(1, 'day').toDate() })
        }
        $stateParams.from = null
        return __guard__(PermPermissionStore.getStore().client, (x) => x.validatePermission()
        .then(() => {
            if (next.url !== '/logout') {
                LogNavigation.log({ url: next.url, additionalInfo: current })
            }
        }))
    })
}

function __guard__(value, transform) {
    return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}



// WEBPACK FOOTER //
// ./src/config/navigation-logger.js